import { BabylonState } from "../../state";

import { applyRenderOrigin } from "./applyRenderOrigin";
import { constrainCamera } from "./constrainCamera";
import { updatePositions } from "./setPositionsToTime";
import { updateVectorFields } from "./setVectorFieldsToTime";
import { updateCamera } from "./updateCamera";

/**
 * Renders the babylon scene to its canvas.
 *
 * Float64-source data is converted to float32 in the graphics pipeline,
 * which loses precision far from the origin. Each frame translates the
 * data-space focus point to render-space `(0,0,0)` so the visible
 * region stays inside float32's precise range. System order keeps that
 * mapping coherent:
 *   1. `updatePositions` / `updateVectorFields` populate data-space
 *      entity positions for the current time.
 *   2. `updateCamera` writes `camera.focusPoint` from per-mode sources
 *      — orbit copies the tracked entity, third-person consumes the
 *      input accumulator.
 *   3. `applyRenderOrigin` translates every mesh by `-camera.focusPoint`.
 *   4. `constrainCamera` clamps zoom, draw distance, and fog.
 *   5. `scene.render` rasterizes.
 */
export function render(state: BabylonState) {
  updatePositions(state);
  updateVectorFields(state);
  updateCamera(state);
  applyRenderOrigin(state);
  constrainCamera(state);

  state.context.scene.render(false);
}
